<template>
  <v-layout wrap align-start>
    <v-flex xs10 md6>
      <!-- <label for="seller">Has seller:</label> -->
      <v-combobox
        chips
        clearable
        multiple
        solo
        hide-details
        v-model="selected_sellers"
        :items="sellers_list"
        label="Sellers"
        id="seller"
        item-text="seller"
        item-value="id"
        background-color="#282732"
      >
        <template v-slot:selection="data">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            @click:close="remove_seller( data.item.id )"
          >
            <strong>{{ data.item.seller }}</strong>
          </v-chip>
        </template>
      </v-combobox>
        <!-- v-model="sellerInvert" -->
        <!-- :disabled="!sellerIds.length > 0" -->
        <!-- @change="$store.commit('productModule/SET_sellerInvert', sellerInvert)" -->
    </v-flex>
    <v-flex xs10 md6>
      <!-- <label for="domains">Has domain:</label> -->
      <v-combobox
        v-model="selected_domains"
        :items="domains_list"
        label="Domains"
        background-color="#282732"
        domains
        clearable
        solo
        multiple
        hide-details
        id="domains"
        item-text="domain"
        item-value="id"
      >
        <!-- @change="$emit('selectedDomains', $event)" -->
        <template v-slot:selection="data">
          <v-chip
            :input-value="data.selected"
            close
            clearable
            @click:close="remove_domain( data.item.id )"
          >
            <strong>{{ data.item.domain }}</strong>
          </v-chip>
        </template>
      </v-combobox>
    </v-flex>
  </v-layout>
</template>

<script>
/* eslint-disable */
export default {
  name: 'N_SellersDomainFilter',
  data: () => ({}),
  computed: {
    sellers_list() {
      return this.$store.state.productionModule.sellers;
    },
    domains_list() {
      return this.$store.state.productionModule.domains;
    },
    selected_sellers: {
      get() {
        return this.$store.state.productionModule.product_filter.selected_sellers;
      },
      set( value ) {
        this.$store.commit('productionModule/SET_SELECTED_SELLERS', value);
      }
    },
    selected_domains: {
      get() {
        return this.$store.state.productionModule.product_filter.selected_domains;
      },
      set( value ) {
        this.$store.commit('productionModule/SET_SELECTED_DOMAINS', value);
      }
    },
  },
  methods: {
    remove_seller(seller_id) {
      this.selected_sellers = this.selected_sellers.filter(x => x.id !== seller_id);
    },
    remove_domain(domain_id) {
      this.selected_domains = this.selected_domains.filter(x => x.id !== domain_id);
    },
    loadSellers () {
      if (this.sellers_list.length == 0) {
        const payload = { task: 'loadSellers' };
        this.$store.dispatch('productionModule/general_api', payload)
        .then(res => {
          console.log('sellers', res.data)
          this.$store.commit('productionModule/SET_SELLERS', res.data.domains)
        })
      }
    },
    loadDomains () {
      if (this.domains_list.length == 0) {
        const payload = { task: 'loadDomains' };
        this.$store.dispatch('productionModule/general_api', payload)
        .then(res => {
          console.log('domains', res.data)
          this.$store.commit('productionModule/SET_DOMAINS', res.data.domains)
        })
      }
    }
  },
  created() {
    this.loadSellers();
    this.loadDomains();
  },
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/production/N_SellersDomainsFilter.vue